import React from "react";

export default function TimestampTableCell({ id, className, children, childSwitch }) {
    // Akzeptiere Strings und Zahlen, filtere leere Werte
    const validChildren = React.Children.toArray(children).filter(
        (child) => (typeof child === "string" || typeof child === "number") && String(child).trim() !== ""
    );

    let content = "";
    let rawValue;
    if (validChildren.length === 1) {
        const raw = validChildren[0];
        rawValue = String(raw).trim();
        let date;

        // Prüfen, ob der Inhalt numerisch ist (z.B. "1650000000" oder 1650000000000)
        const numeric = /^[+-]?\d+(\.\d+)?$/.test(rawValue);
        const num = Number(rawValue);

        if (numeric && Number.isFinite(num)) {
            // Unterscheide Sekunden vs Millisekunden: Werte mit Betrag < 1e12 sind Sekunden
            const abs = Math.abs(num);
            const ms = abs < 1e12 ? num * 1000 : num;
            date = new Date(ms);
        } else {
            // Versuch, den String als Datum zu parsen (ISO etc.)
            date = new Date(rawValue);
        }

        if (date && !Number.isNaN(date.getTime())) {
            content = date.toLocaleString(undefined, {
                year: "numeric",
                month: "numeric",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                // second wird weggelassen
            });
        } else {
            content = "Invalid date";
        }
    }

    return (
        <td
            key={id}
            className={`border px-4 py-2 text-nowrap text-end${className ? " " + className : ""}`}
        >
            {childSwitch} {content}
        </td>
    );
}
